import http from './http';

export default {
  all() {
    return http().get(`/v1/notes`);
  },
  allForRecord(recordId) {
    return http().get(`/v1/notes/${recordId}/record`);
  },
  get(id) {
    return http().get(`/v1/notes/${id}`);
  },
  create(data, validationErrors) {
    return http(validationErrors).post(`/v1/notes`, data);
  },
  update(data) {
    return http().put(`/v1/notes/${data.id}`, data);
  },
  pin(id) {
    return http().put(`/v1/notes/${id}/pinned`);
  },
  unpin(id) {
    return http().put(`/v1/notes/${id}/unpinned`);
  },
  delete(id) {
    return http().delete(`/v1/notes/${id}`);
  },
}
